import React from "react";
import { TextField } from "@vitalsource/vstui";
import { t } from "../../../core/translate";
import { Flex } from "../styles";

export default () => (
  <Flex>
    <TextField
      required
      id="first-name"
      type="text"
      name="user[first_name]"
      label={t("base.firstname", "First Name")}
      rootProps={{
        style: {
          display: "inline-block",
          marginRight: "10px",
          width: "calc(50% - 5px)"
        }
      }}
    />
    <TextField
      required
      id="last-name"
      type="text"
      name="user[last_name]"
      label={t("base.lastname", "Last Name")}
      rootProps={{
        style: {
          display: "inline-block",
          width: "calc(50% - 5px)"
        }
      }}
    />
  </Flex>
);
